// src/components/QRCodeModal.js
import React, { useRef } from 'react';
import QRCode from 'react-qr-code';
import { X, Download } from 'lucide-react';
import styles from './QRCodeModal.module.css';

const QRCodeModal = ({ isOpen, onClose, profileUrl, username }) => {
  const qrRef = useRef(null);

  if (!isOpen) return null;

  const handleDownload = () => {
    const canvas = document.createElement("canvas");
    const svg = document.getElementById("profile-qr-code");
    const svgData = new XMLSerializer().serializeToString(svg);
    const img = new Image();
    
    img.onload = () => {
      // Set canvas dimensions (slightly larger for better quality)
      canvas.width = 1024;
      canvas.height = 1024;
      
      // Fill background white
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // Draw the QR code
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      
      // Add profile info text below QR code
      ctx.font = "bold 48px Arial";
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.fillText(`linkist.se/${username}`, canvas.width / 2, canvas.height - 100);
      
      // Create download link
      const downloadLink = document.createElement("a");
      downloadLink.download = `linkist-${username}-qrcode.png`;
      downloadLink.href = canvas.toDataURL("image/png");
      downloadLink.click();
    };
    
    img.src = "data:image/svg+xml;base64," + btoa(svgData);
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2>Profile QR Code</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <X size={24} />
          </button>
        </div>
        
        <div className={styles.qrCodeContainer}>
          <QRCode
            id="profile-qr-code"
            value={profileUrl}
            size={256}
            level="H"
            className={styles.qrCode}
            ref={qrRef}
          />
          <p className={styles.profileUrl}>{profileUrl}</p>
        </div>
        
        <div className={styles.instructions}>
          <p>Share your profile by letting others scan this QR code</p>
        </div>
        
        <button className={styles.downloadButton} onClick={handleDownload}>
          <Download size={16} /> Download QR Code
        </button>
      </div>
    </div>
  );
};

export default QRCodeModal;